import { debounce } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { getJobTitles, IJobSuggestions } from 'wisestep-api';
import { WsAutoComplete } from 'wisestep-base';

import {
  getJobIdsFromJobCode,
  getJobTitlesWithCodes,
} from '../../../features/jobs/helper/jobsFiltersHelper';

interface IJobTitleFilterNew {
  name: string;
  placeholder: string;
  multiple: boolean;
  freeSolo: boolean;
  defaultValue?: IJobSuggestions[];
  reset?: boolean;
}

const JobTitleFilterNew = ({
  name,
  placeholder,
  multiple,
  freeSolo,
  defaultValue = [],
  reset = false,
}: IJobTitleFilterNew) => {
  const [jobsList, setJobList] = useState<IJobSuggestions[]>([]);
  const [selectedJobs, setSelectedJobs] = useState<string[]>([]);
  const [selectedOptions, setSelectOptions] = useState<IJobSuggestions[]>(defaultValue);
  const [flag, setflag] = useState<boolean>(false);
  const { setValue } = useFormContext();
  const debouncedSearch = debounce(async (searchText: string) => {
    try {
      setflag(false);
      const response = await getJobTitles(searchText);
      setJobList(response?.data ?? []);
      setSelectedJobs(getJobTitlesWithCodes(response));
    } catch (error) {
      setJobList([]);
    }
  }, 500);

  const onSearchKey = (searchText: string): Promise<void> => {
    debouncedSearch(searchText);
    return Promise.resolve();
  };

  useEffect(() => {
    if (reset) {
      setflag(reset);
      setSelectedJobs([]);
      setSelectOptions([]);
    }
  }, [reset]);

  const getSelectedJob = (selectedJobList: string[]) => {
    const res = getJobIdsFromJobCode([...jobsList, ...selectedOptions], selectedJobList);
    setSelectOptions(res as IJobSuggestions[]);
    setValue(name, res);
  };
  return (
    <WsAutoComplete
      onValueEnter={onSearchKey}
      onTagsChange={getSelectedJob}
      value={defaultValue.map((data) => `${data?.title} (${data?.jobCode})`)}
      initialValue={['']}
      placeholder={placeholder}
      optionsInStringArray={selectedJobs}
      multiple={multiple}
      freeSolo={freeSolo}
      name={name}
      size="small"
      resetValue={flag}
    />
  );
};

export default JobTitleFilterNew;
